import * as THREE from 'three';
import { createCamera } from './camera.js';
import { createRenderer } from './renderer.js';
import { createLights } from './lights.js';
import { createGround } from './ground.js';
import { createPost } from './post.js';

/**
 * The boot scene: camera, lights, ground and a render loop hook.
 * Everything else in the game is added to `scene` by its own module.
 */
export function createStage(canvas) {
  const scene = new THREE.Scene();
  scene.background = new THREE.Color(0x0b0d12);
  scene.fog = new THREE.Fog(0x0b0d12, 18, 45);

  const camera = createCamera();
  const { renderer, dispose } = createRenderer(canvas, camera);

  // Grouped rather than loose, for the same reason as the ground: an arena
  // that lights itself has to be able to switch the outdoor key light off.
  const lights = new THREE.Group();
  lights.name = 'stage-lights';
  for (const light of createLights()) lights.add(light);
  scene.add(lights);
  // Kept as a handle rather than dropped in and forgotten: an arena that brings
  // its own floor has to be able to take this one away, and a grid drawn over
  // a subway platform — and straight across the hole where the track is — is
  // worse than no floor at all.
  const ground = createGround();
  scene.add(ground);
  // Bloom, grade and vignette, per arena (step 98). Off until an arena asks.
  const post = createPost(renderer);

  return {
    scene,
    camera,
    renderer,
    ground,
    lights,
    /** Shows or hides the default floor. Arenas with their own call this. */
    showGround(visible) {
      ground.visible = Boolean(visible);
    },
    /** Shows or hides the default lights. Arenas with their own call this. */
    showLights(visible) {
      lights.visible = Boolean(visible);
    },
    post,
    render() {
      post.render(scene, camera);
    },
    dispose() {
      post.dispose();
      dispose();
    },
  };
}
